import GoalsAdapter from './base';

export default class Category extends GoalsAdapter {
  modelNamePlural = 'categories';
}
